<template>
  <section id="step-three" class="pb-8">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <h1 class="pt-6 font-weight-bold display-2 mb-5 text-center">
            Step 3: Pay
          </h1>
          <!-- line A -->
          <v-row align="start" justify="center">
            <v-col
              class="text-center"
              lg="4"
              xs="12"
              v-for="(itemA, index) in paymentScreenA"
              :key="'payA' + index"
            >
              <div class="text-h5 font-weight-bold">
                <v-avatar color="deep-purple darken-3" size="35" class="mb-2">
                  <span class="white--text text-h6">{{ itemA.no }}</span>
                </v-avatar>
              </div>
              <mobileframe title="pay" :name="itemA.img">
                <div class="text-center font-weight-bold">
                  <span v-html="itemA.title"></span>
                </div>
                <div class="text--primary">
                  <span v-html="itemA.description"></span>
                </div>
                <!--  
                  <div v-if="itemA.no === '2'">
                    <p class="mt-2 mb-1">
                      <span style="color: #3249ff" class="font-weight-bold mr-2"
                        >1. Available</span
                      >You can make payment now.
                    </p>
                    <v-divider class="my-2"></v-divider>
                    <p class="mt-0 mb-1">
                      <span style="color: #ffc900" class="font-weight-bold mr-2"
                        >2. Pending</span
                      >Your payment is waiting confirmation.
                    </p>
                    <v-divider class="my-2"></v-divider>
                    <p class="mt-0 mb-1">
                      <span style="color: #197579" class="font-weight-bold mr-2"
                        >3. Complete</span
                      >Your payment is complete.
                    </p>
                    <v-divider class="my-2"></v-divider>
                    <p class="mt-0 mb-1">
                      <span class="font-weight-bold mr-2">4. Not available</span
                      >You cannot pay right now.
                    </p>
                  </div>
                -->
              </mobileframe>
            </v-col>
          </v-row>
          <!-- line B -->
          <!-- <div class="mt-5 text-center mb-3 text-h5 font-weight-bold">
            <v-avatar color="deep-purple darken-3" size="35" class="mb-2">
              <span class="white--text text-h6">3</span>
            </v-avatar>
          </div> -->
          <v-row align="start" justify="center">
            <v-col
              class="text-center"
              lg="4"
              xs="12"
              v-for="(itemB, index) in paymentScreenB"
              :key="'payB' + index"
            >
              <div class="text-h5 font-weight-bold">
                <v-avatar color="deep-purple darken-3" size="35" class="mb-2">
                  <span class="white--text text-h6">{{ itemB.no }}</span>
                </v-avatar>
              </div>
              <mobileframe title="pay" :name="itemB.img">
                <div class="">
                  <strong>{{ itemB.title }}</strong>
                </div>
                <div class="text--primary">
                  <span v-html="itemB.description"></span>
                </div>
              </mobileframe>
            </v-col>
          </v-row>
          <v-row class="mb-5">
            <v-col>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="pt-5">
        <v-col>
          <div class="svg-border-rounded text-light">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1440 320"
              preserveAspectRatio="none"
              fill="currentColor"
            >
              <path
                d="M0,64L80,90.7C160,117,320,171,480,181.3C640,192,800,160,960,138.7C1120,117,1280,107,1360,101.3L1440,96L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
              ></path>
            </svg>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import mobileframe from "@/components/shared/MobileFrame";
export default {
  components: {
    mobileframe,
  },
  data: () => ({
    paymentScreenA: [
      {
        no: "1",
        img: "bg-pay-01",
        title: "",
        description:
          "To begin, navigate to the <strong>“Payment List”</strong> menu.",
      },
      {
        no: "2",
        img: "bg-pay-02",
        title: "",
        description:
        "Tab “Acknowledge & Confirm” for payment detail."
          // "Tap “Display Tuition” for payment detail. Your payment status is also shown here.",
        // "Tap “Display Tuition” to see more detail of the payment. Your payment status is shown on screen.",
      },
      {
        no: "3",
        img: "bg-pay-06",
        title: "Acknowledge & Confirm",
        description:
        "Make sure this registration result is correct and click <strong>“Confirm”</strong> to confirm your registration.",
      },
    ],
    paymentScreenB: [
      {
        no: "3",
        img: "bg-pay-03",
        title: "",
        description:
          "Select a payment method of your choice in the <strong>“Payment Method”</strong> section. ",
      },
      {
        no: "4",
        img: "bg-pay-04",
        title: "Make your payment",
        description:
          "You can pay with credit cards or QR code. If you use <strong>QR code</strong> or <strong>barcode</strong> to make payment, you can capture the QR code and use any mobile banking application to pay.<br /><b>Remarks: There will be processing fees when you use your credit cards</b>",
      },
    ],
  }),
};
</script>

<style lang="scss">
$main_color: #283e79;
ul {
  font-size: 13px;
  line-height: 1.5em;
  margin: 5px 0 15px;
  padding: 0;

  li {
    list-style: none;
    position: relative;
    padding: 0 0 0 20px;
  }

  li {
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 5px;
      width: 10px;
      height: 10px;
      background-color: $main_color;
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-eeborder-radius: 50%;
    }
  }
}
</style>

<style scoped>
.header {
  background-color: #283e79;
  color: white;
}
.circle1 {
  border-radius: 50%;
  width: 150px;
  height: 150px;
  background-color: #f0f8ff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.circle2 {
  border-radius: 50%;
  width: 100px;
  height: 100px;
  background-color: #e0effc;
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.svg-border-rounded svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #f4f7f5;
  z-index: -1;
}
#step-three {
  z-index: 0;
}
.content {
  z-index: 1;
}
svg {
  overflow: hidden;
}
section {
  position: relative;
}
</style>